import {
  faArrowLeft,
  faAsterisk,
  faBan,
  faBars,
  faBell,
  faBook,
  faCalendarAlt,
  faCheck,
  faCloud,
  faCogs,
  faDatabase,
  faEye,
  faFlag,
  faHeart,
  faHome,
  faList,
  faLock,
  faPencilAlt,
  faPlus,
  faRoad,
  faSave,
  faSearch,
  faSignOutAlt,
  faSignInAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSync,
  faTachometerAlt,
  faTasks,
  faThList,
  faTimes,
  faTrashAlt,
  faUser,
  faUserPlus,
  faUsers,
  faUsersCog,
  faWrench,
  // jhipster-needle-add-icon-import
} from '@fortawesome/free-solid-svg-icons';

export const fontAwesomeIcons = [
  faArrowLeft,
  faAsterisk,
  faBan,
  faBars,
  faBell,
  faBook,
  faCalendarAlt,
  faCheck,
  faCloud,
  faCogs,
  faDatabase,
  faEye,
  faFlag,
  faHeart,
  faHome,
  faList,
  faLock,
  faPencilAlt,
  faPlus,
  faRoad,
  faSave,
  faSearch,
  faSignOutAlt,
  faSignInAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSync,
  faTachometerAlt,
  faTasks,
  faThList,
  faTimes,
  faTrashAlt,
  faUser,
  faUserPlus,
  faUsers,
  faUsersCog,
  faWrench,
  // jhipster-needle-add-icon-import
];
